/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    SAVE: 'Tallenna',
    SUBMIT: 'Lähetä'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Virhe vastapuolta peruutettaessa',
    COUNTERPART_DETAILS_SUBMIT: 'Virhe vastineen toimittamisessa',
    DELETE_ATTACHMENT: 'Virhe liitetiedoston poistamisessa',
    DELETE_LINK: 'Virhe linkin poistamisessa',
    ERROR: 'Virhe',
    FILE_SIZE: 'Valittu tiedosto ylittää 8 Mt:n rajan.',
    MAX_FILES_UPLOAD: 'Voit lähettää enintään 8 Mt kerrallaan.',
    PUBLISHED_AT_ERROR: 'Julkaisupäivä on pakollinen'
  },
  HEADER: {
    APPROVED_BY: 'Hyväksynyt',
    ATTACHMENT: 'Liitteet',
    COMMENT: 'Kommentti',
    CONFIRMATION_DATE: 'Vahvistus',
    CURRENT_PARTNER_TASKS: 'P. Corr',
    DESCRIPTION: 'Kuvaus',
    END_DATE: 'Loppupäivä',
    LINK: 'Linkit',
    MANAGER_COMMENT: 'Managerin kommentti',
    MONTH: 'Kuukausi',
    PERIODICITY: 'Taajuus',
    PREVIOUS_PARTNER_TASKS: 'P. Ant',
    REQUIRED: 'Vaadittu',
    START_DATE: 'Aloituspäivä',
    STATE: 'Valtio',
    SUBMISSION_DATE: 'Toimitusosoite'
  },
  LABEL: {
    ATTACHMENTS: 'Liitteet',
    ATTACHMENTS_UPLOADED: 'Ladatut liitetiedostot',
    CANCEL_COUNTERPART: 'Peruuta',
    CLOSE: 'Sulje',
    COMMENT: 'Kommentti',
    CONFIRM: 'Vahvista',
    DESCRIPTION: 'Kuvaus',
    FILTER_MONTH_APR: 'Huhtikuu',
    FILTER_MONTH_AUG: 'Elokuu',
    FILTER_MONTH_DEC: 'Joulukuu',
    FILTER_MONTH_FEB: 'Helmikuu',
    FILTER_MONTH_JAN: 'Tammikuu',
    FILTER_MONTH_JUL: 'Heinäkuu',
    FILTER_MONTH_JUN: 'Kesäkuu',
    FILTER_MONTH_MAR: 'Maaliskuu',
    FILTER_MONTH_MAY: 'Toukokuu',
    FILTER_MONTH_NOV: 'Marraskuu',
    FILTER_MONTH_OCT: 'Lokakuu',
    FILTER_MONTH_SEP: 'Syyskuu',
    LINK: 'Linkki',
    LINKS: 'Linkit',
    LINKS_UPLOADED: 'Ladatut linkit',
    MONTH: 'Kuukausi',
    PUBLISHED_AT: 'Julkaisupäivä',
    STATE: 'Valtio',
    SUBMIT_COUNTERPART: 'Lähetä',
    YEAR: 'Vuosi'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Oletko varma, että haluat peruuttaa vastineen lähettämisen?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Oletko varma, että haluat lähettää vastineen?',
    NO_ROWS_ATTACHMENT: 'Ei liitteitä'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Poistetaan liite.',
    CANCEL_COUNTERPART: 'Vastapuoli peruutettu',
    COUNTERPART_DETAILS_SUBMIT: 'Vastapuolen toimittamat tiedot',
    LINK_DELETED: 'Linkki poistettu',
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    ADD_LINK: 'Uusi linkki',
    APPROVED_BY: 'Vastapuolen hyväksynyt',
    ATTACHMENT: 'Liitteet',
    COMMENT: 'Kommentti',
    CONFIRMATION_DATE: 'Vastapuolen vahvistuspäivä',
    CURRENT_PARTNER_TASKS:
      'Kumppanin toimittamien kuluvan kauden tietueiden lukumäärä',
    DESCRIPTION: 'Kuvaus',
    END_DATE: 'Loppupäivä',
    LINK: 'Linkit',
    MANAGER_COMMENT: 'Johtajan kommentti',
    MONTH: 'Kuukausi',
    PERIODICITY: 'Taajuus',
    PREVIOUS_PARTNER_TASKS:
      'Kumppanin vielä toimittamatta olevien edellisen kauden tietueiden lukumäärä.',
    REMOVE_LINK: 'Poista linkki',
    REQUIRED: 'Vaadittu',
    START_DATE: 'Aloituspäivä',
    STATE: 'Valtio',
    SUBMISSION_DATE: 'Vastineen toimittamispäivä'
  }
};
